import { robinMediaArray } from './robinMedia'
import { robinBio } from './robinBios'

import { tedReviewerReviewHinge, tedReviewerReviewBumble, barneyReviewerReviewTinder } from './robinReviewerReviews'
import { tedReviewerProfile, barneyReviewerProfile } from './robinReviewers'

export const tedProfileReviewHinge = {
  _id: 'tedProfileReviewHingeId',
  userId: 'robinUserId',
  userEmail: 'robin@email.com',
  datingProfileId: 'robinDatingProfileHingeId',
  reviewerProfileId: 'tedReviewerProfileId',
  reviewerEmail: 'ted@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stunning! Why are you even on the apps? Go on a date with me instead`,
      verdict: 'Very',
    },
    {
      feedback: `Uhh... too authentic... maybe don't show this side of yourself until the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Another incredible glamor shot. But you're always at the bar. Maybe add some variety, like a beach or Pilates pic`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny and you look good. A hot chick who drinks whiskey and plays poker — jackpot`,
      verdict: 'Very',
    },
    {
      feedback: `Supermodel alert! Another stunning but duplicative glamor shot of you in a bar`,
      verdict: 'Yes',
    },
    {
      feedback: `This is grotesque`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Interesting background and seems well oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Meh, too vague and unoriginal. I want to learn a new tidbit about you`,
        verdict: 'No', 
      },
      {
        feedback: `Depicts as a babe you can bro out with, which is good, but it shows up in the photos. Add more variety to round out your character`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Robin is very pretty, well put together, and up for traditionally masculine activities like poker and watching sports.`,
    good: `A hot babe who you can bro out with is always in high demand`,
    notGood: `Not enough variety. There are three glamor shots at the bar, and some of the others just aren't good photos. How about a photo of you at the beach, on TV, or at home with your pet moose`,
    verdict: `Because you're hot you'll get a lot of right swipes, but your profile will be vastly improved by adding variety and improfing your prompt responses`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...tedReviewerReviewHinge },
  reviewerProfile: { ...tedReviewerProfile },
  bioItems: { ...robinBio },
  mediaItems: [ ...robinMediaArray ],
}

export const tedProfileReviewBumble = {
  _id: 'tedProfileReviewBumbleId',
  userId: 'robinUserId',
  userEmail: 'robin@email.com',
  datingProfileId: 'robinDatingProfileBumbleId',
  reviewerProfileId: 'tedReviewerProfileId',
  reviewerEmail: 'ted@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stunning! Why are you even on the apps? Go on a date with me instead`,
      verdict: 'Very',
    },
    {
      feedback: `Uhh... too authentic... maybe don't show this side of yourself until the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Another incredible glamor shot. But you're always at the bar. Maybe add some variety, like a beach or Pilates pic`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny and you look good. A hot chick who drinks whiskey and plays poker — jackpot`,
      verdict: 'Very',
    },
    {
      feedback: `Supermodel alert! Another stunning but duplicative glamor shot of you in a bar`,
      verdict: 'Yes',
    },
    {
      feedback: `This is grotesque`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: robinBio.aboutMe[0],
    hobbies: [robinBio.hobbies[0], robinBio.hobbies[1], robinBio.hobbies[2], robinBio.hobbies[3], robinBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Interesting background and seems well oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'This is good',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Meh, too vague and unoriginal. I want to learn a new tidbit about you`,
        verdict: 'No', 
      },
      {
        feedback: `Depicts as a babe you can bro out with, which is good, but it shows up in the photos. Add more variety to round out your character`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Robin is very pretty, well put together, and up for traditionally masculine activities like poker and watching sports.`,
    good: `A hot babe who you can bro out with is always in high demand`,
    notGood: `Not enough variety. There are three glamor shots at the bar, and some of the others just aren't good photos. How about a photo of you at the beach, on TV, or at home with your pet moose`,
    verdict: `Because you're hot you'll get a lot of right swipes, but your profile will be vastly improved by adding variety and improfing your prompt responses`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...tedReviewerReviewBumble },
  reviewerProfile: { ...tedReviewerProfile },
  bioItems: { ...robinBio },
  mediaItems: [ ...robinMediaArray ],
}

export const barneyProfileReviewTinder = {
  _id: 'barneyProfileReviewTinderId',
  userId: 'robinUserId',
  userEmail: 'robin@email.com',
  datingProfileId: 'robinDatingProfileTinderId',
  reviewerProfileId: 'barneyReviewerProfileId',
  reviewerEmail: 'barney@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stunning! Why are you even on the apps? Go on a date with me instead`,
      verdict: 'Very',
    },
    {
      feedback: `Uhh... too authentic... maybe don't show this side of yourself until the third date`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Another incredible glamor shot. But you're always at the bar. Maybe add some variety, like a beach or Pilates pic`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny and you look good. A hot chick who drinks whiskey and plays poker — jackpot`,
      verdict: 'Very',
    },
    {
      feedback: `Supermodel alert! Another stunning but duplicative glamor shot of you in a bar`,
      verdict: 'Yes',
    },
    {
      feedback: `This is grotesque`,
      verdict: 'No',
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: robinBio.aboutMe[0],
    hobbies: [robinBio.hobbies[0], robinBio.hobbies[1], robinBio.hobbies[2], robinBio.hobbies[3], robinBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Interesting background and seems well oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'This is good',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Meh, too vague and unoriginal. I want to learn a new tidbit about you`,
        verdict: 'No', 
      },
      {
        feedback: `Depicts as a babe you can bro out with, which is good, but it shows up in the photos. Add more variety to round out your character`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Robin is very pretty, well put together, and up for traditionally masculine activities like poker and watching sports.`,
    good: `A hot babe who you can bro out with is always in high demand`,
    notGood: `Not enough variety. There are three glamor shots at the bar, and some of the others just aren't good photos. How about a photo of you at the beach, on TV, or at home with your pet moose`,
    verdict: `Because you're hot you'll get a lot of right swipes, but your profile will be vastly improved by adding variety and improfing your prompt responses`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...barneyReviewerReviewTinder },
  reviewerProfile: { ...barneyReviewerProfile },
  bioItems: { ...robinBio },
  mediaItems: [ ...robinMediaArray ],
}